import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledBreadcrumb, StyledBreadcrumbItem, StyledIcon } = Styles;

export const Breadcrumb = ({ children, ...otherProps }) => {
    const childrenArray = React.Children.toArray(children).flatMap((child, index) => (
        <StyledBreadcrumbItem key={index.toString()}>
            {child}
            <StyledIcon icon={['fal', 'chevron-right']} size="xs" />
        </StyledBreadcrumbItem>
    ));

    return <StyledBreadcrumb {...otherProps}>{childrenArray}</StyledBreadcrumb>;
};

Breadcrumb.propTypes = {
    children: PropTypes.node.isRequired,
};

Breadcrumb.defaultProps = {};

Breadcrumb.Styles = Styles;
